<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("user", 1) }}</div>
        <div class="section-subTitle my-2">{{ $t("cinemauser") }}</div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Users')"
          :disabled="isRoleID"
          variant="default"
          to="/user-management/add-edit-app-report-users"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
    </div>

    <table class="list-view-table">
      <thead>
        <th>Name</th>
        <th>Mobile</th>
        <th>Email</th>
        <th>Status</th>
      </thead>
      <tbody>
        <tr v-for="(user, userKey) in users" :key="userKey">
          <td>{{ user.name }}</td>
          <td>{{ user.mobile }}</td>
          <td>{{ user.email }}</td>
          <td>{{ user.isActive }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <!-- <label class="ios-switch">
                <input
                  :checked="user.is_active == 'Y'"
                  disabled
                  type="checkbox"
                  class="ios-checkbox"
                />
                <span class="switch-slider"></span>
              </label> -->
              <!-- <StatusDot
                :status="
                  user.is_active === 'Y'
                    ? 'active'
                    : user.is_active === 'N' && 'inactive'
                "
              /> -->

              <b-button
                v-if="$can('create', 'Users')"
                :disabled="isRoleID"
                variant="default"
                :to="
                  `/user-management/add-edit-app-report-users/${user.userId}`
                "
                class="btn-blue"
                >{{ $t("edit") }}</b-button
              >
            </div>
          </td>
        </tr>
      </tbody>

      <tbody v-if="users.length == 0">
        <tr>
          <td colspan="6">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <br />
  </div>
</template>

<script>
  import UserService from "@/services/UserService";
  import MasterService from "@/services/MasterService";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  export default {
    components: {
      StatusDot,
      NoRecords,
    },
    data() {
      return {
        users: [],
      };
    },
    mounted() {
      this.getUserList();
    },
    beforeMount() {
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      const { user_id } = this.secureStore.get("USINFO");
      this.userid = user_id;
    },
    methods: {
      getUserList: function() {
        let loader = this.$loading.show();
        UserService.getAllReportAppUser()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.data.length > 0) {
              this.users = [...data.data];
            }
            this.$toasted.show(data.message);
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
      /* eslint-disable */
      onEditUser: function(user) {
        this.$router.push({
          path: "/user-management/edit-user",
          query: { user_id: user.user_id },
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/ReportAppUsers/getReportAppUsers.vue